import { render, staticRenderFns } from "./Formulario.vue?vue&type=template&id=7c581c05&scoped=true&lang=pug&"
import script from "./Formulario.vue?vue&type=script&lang=js&"
export * from "./Formulario.vue?vue&type=script&lang=js&"
import style0 from "./Formulario.styl?vue&type=style&index=0&id=7c581c05&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c581c05",
  null
  
)

export default component.exports